export function injectNonVisualThumbnail(hostElement: HTMLElement, thumbnailUrl: string): void {
  const eventPlane = hostElement.querySelector(".event-plane.unselectable");
  if (!eventPlane) return;

  const img = document.createElement("img");
  img.src = thumbnailUrl;
  img.classList.add("intiaro-non-visual-thumbnail");
  img.style.cssText = "position:absolute;top:0;left:0;width:100%;height:100%;object-fit:contain;z-index:1000;";

  const slider = eventPlane.querySelector(".slider");
  eventPlane.insertBefore(img, slider);
}
